import React, { useState, useEffect } from 'react';
import { Col, Container, Row, Button, Modal, Form } from 'react-bootstrap';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';
import axios from 'axios'; // Import axios for making API requests
import Cookies from 'js-cookie'; // Import Cookies for setting and getting cookies

const AssignmentsDetails = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedTeacher, setSelectedTeacher] = useState('');
  const [essayDetails, setEssayDetails] = useState(null);
  const [teachers, setTeachers] = useState([]);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const handleAssign = () => {
    if (selectedTeacher) {
      axios
        .put(`https://backend.writerswright.com/api/v1/admin/jobrequest?Id=${Cookies.get("essayId")}&teacherId=${selectedTeacher}`, {
          essayId: Cookies.get("essayId"),
          teacherId: selectedTeacher,
        })
        .then((response) => {
          setShowModal(false);
          // Fetch essay details from the API
          axios
            .get(`https://backend.writerswright.com/api/v1/admin/getEssayDetails?Id=${Cookies.get("essayId")}`)
            .then((response) => {
              setEssayDetails(response.data.essay);
              setTeachers(response.data.teachers);
            })
            .catch((error) => {
              console.error('Error fetching essay details:', error);
            });
        })
        .catch((error) => {
          console.error('Error assigning teacher:', error);
        });
    }
  };

  const navigate = useNavigate();

  const navigateToTeachersDetails = () => {
    navigate('/admin-portal/teachers-details');
  };

  useEffect(() => {
    // Fetch essay details from the API
    axios
      .get(`https://backend.writerswright.com/api/v1/admin/getEssayDetails?Id=${Cookies.get("essayId")}`)
      .then((response) => {
        setEssayDetails(response.data.essay);
        setTeachers(response.data.teachers);
      })
      .catch((error) => {
        console.error('Error fetching essay details:', error);
      });
  }, []);

  return (
    <Container>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className='title'>Assignment Details</h2>
        <button className='button-37' onClick={handleShow}>Assign To Teacher</button>
      </div>
      {essayDetails && (
        <div
          style={{
            width: "100%",
            height: "100%",
            margin: "10px auto",
            borderRadius: "10px",
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px"
          }}
        >
          <Row style={{ padding: "5% 10%" }}>
            <Col lg={6} md={6} sm={12}>
              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: "var(--primary)" }}>Essay Name</strong>
              </div>
              <div style={{ marginBottom: '20px' }}>{essayDetails.Title}</div>

              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: "var(--primary)" }}>Due Date</strong>
              </div>
              <div style={{ marginBottom: '20px' }}>{new Date(essayDetails.deadline).toLocaleString()}</div>

              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: "var(--primary)" }}>Status</strong>
              </div>
              <div style={{ marginBottom: '20px' }}>{essayDetails.Status}</div>
            </Col>
            <Col lg={6} md={6} sm={12}>
              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: "var(--primary)" }}>Student Name</strong>
              </div>
              <div style={{ marginBottom: '20px' }}>{essayDetails.Name}</div>

              <div style={{ marginBottom: '10px' }}>
                <strong style={{ color: "var(--primary)" }}>Essay Details</strong>
              </div>
              <div style={{ marginBottom: '20px' }}>{essayDetails.details}</div>
            </Col>
          </Row>
        </div>
      )}
      <div style={{ marginBottom: "20px" }}>
        <h2 className='title'>Teachers Sent Request for this assignment</h2>
        <MDBTable bordered>
          <MDBTableHead>
            <tr>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className='text'>Sr</th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className='text'>Name</th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className='text'>Email</th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className='text'>Contact</th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className='text'>Assigned Essays</th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className='text'>Details</th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className='text'>Approvals</th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            {teachers.map((teacher, index) => (
              <tr key={teacher.Id}>
                <td>{index + 1}</td>
                <td>{teacher.Name}</td>
                <td>{teacher.Email}</td>
                <td>{teacher.Contact}</td>
                <td>{teacher.assignedEssaysCount || 0}</td>
                <td>
                  <button onClick={() => { Cookies.set('uId', teacher.Id); navigateToTeachersDetails() }} style={{ color: "black", background: "none", border: "none", textDecoration: "underline" }}>View More</button>
                </td>
                <td>
                  {teacher.status === 'Pending' ? (<span style={{ color: 'orange' }}>{teacher.status}</span>) : (
                    <div>
                      {teacher.status === 'Approved' ? (<span style={{ color: 'green' }}>{teacher.status}</span>) : (
                        <div>
                          {teacher.status === 'Rejected' ? (<span style={{ color: 'red' }}>{teacher.status}</span>) : (<span style={{ color: 'blue' }}>{teacher.status}</span>)}
                        </div>
                      )}
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </MDBTableBody>
        </MDBTable>
      </div>

      {/* Modal for assigning the teacher */}
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Assign To Teacher</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="selectTeacher">
              <Form.Label>Select Teacher</Form.Label>
              <Form.Control
                as="select"
                value={selectedTeacher}
                onChange={(e) => setSelectedTeacher(e.target.value)}
              >
                <option value="">Teacher...</option>
                {teachers.map((teacher) => (
                  <option key={teacher.Id} value={teacher.Id}>
                    {teacher.Name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button className='button-37 w-100' onClick={handleAssign}>
            Assign
          </button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default AssignmentsDetails;
